export default "__VITE_ASSET__74f55626__"